import { useAuth } from "../../../../context";
import { useMutation } from "react-query";
import { ScopeThree } from "../../../../api/supplier-questionnaire/tabs";

export function useUpdateScopeThree(config) {
  const { callApi } = useAuth();
  return useMutation(({questionnaireId, data}) =>
    callApi(ScopeThree.updateScopeThree, { questionnaireId, data }), config);
}